import template from './currency_pick_report.html';
import controller from './currency_pick_report.controller';
import './currency_pick_report.scss';

let currencyPickReportComponent = {
  template,
  controller,
  bindings: {}
};

export default currencyPickReportComponent;



// WEBPACK FOOTER //
// ./client/app/components/order_packing/currency_pick_report/currency_pick_report.component.js